import type { UniversalTabValue } from "../../constants";
import type { UniversalSearchCurrentData } from "../../hooks/use-universal-search-form";

type EmptyStateTabs = {
  currentTabName: string;
  tabs: Array<{ value: UniversalTabValue; name: string }>;
};

export const EMPTY_STATE_TABS: Record<UniversalTabValue, EmptyStateTabs> = {
  JOBS: {
    currentTabName: "Jobs",
    tabs: [{ value: "PEOPLE", name: "People" }],
  },
  PEOPLE: {
    currentTabName: "People",
    tabs: [{ value: "JOBS", name: "Jobs" }],
  },
};

export const TAB_TO_RESULTS_MAP: Record<
  UniversalTabValue,
  keyof UniversalSearchCurrentData
> = {
  PEOPLE: "talentResults",
  JOBS: "jobResults",
};
